<template>
  <form role="search" :aria-label="jobTrackerTitle" v-on:submit.prevent="formSubmit">
    <div class="c-job-tracker__search-control">
      <div class="c-job-tracker__search-field-wrap">
        <input
          class="c-job-tracker__search-field"
          name="jobSearchTerm"
          id="jobSearch"
          type="search"
          :aria-label="jobSearchPlaceholder"
          v-model="jobSearchTerm"
          :placeholder="jobSearchPlaceholder"
        >
      </div>
      <input
        class="c-button c-button--brand"
        type="submit"
        role="button"
        :aria-label="jobSearchButtonText"
        :disabled="!jobSearchTerm"
        :value="jobSearchButtonText"
      >
    </div>
  </form>
</template>

<script>
import 'babel-polyfill'

export default {
  name: 'JobSearch',
  props: {
    jobSearchPlaceholder: {
      type: String
    },
    jobSearchButtonText: {
      type: String
    },
    jobSearchTerm: {
      type: String
    }
  },
  methods: {
    formSubmit() {
      if (this.jobSearchTerm) {
        this.$emit('formSearch', this.jobSearchTerm)
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/components/consumer/job-tracker/JobSearch.vue